//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import { AuthContext } from '../context/auth-context'
import SearchByTeam from '../components/UIElements/SearchByTeam'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import Banner from '../../shared/components/Navigation/Banner'
import backstromBoys from '../../images/teamLogos/Backstrom boys.png'
import berserkers from '../../images/teamLogos/Berserkers 2.png'
import blackWidows from '../../images/teamLogos/Black Widows.png'
import bolts from '../../images/teamLogos/Bolts.jpg'
import bombers from '../../images/teamLogos/Bombers.png'
import bonnieNClyde from '../../images/teamLogos/Bonnie n clyde.jpg'
import capitalPunishment from '../../images/teamLogos/Capital punishment.png'
import chops from '../../images/teamLogos/Carolina chops.png'
import chernobyl from '../../images/teamLogos/Chernobyl.png'
import chimneyFish from '../../images/teamLogos/Chimney fish.png'
import dcCorruption from '../../images/teamLogos/Dc corruption.jpg'
import ehHoles from '../../images/teamLogos/Eh-holes.png'
import firstLadies from '../../images/teamLogos/First ladies.jpg'
import freeze from '../../images/teamLogos/Freeze.png'
import gjwthf from '../../images/teamLogos/GJWTHF.png'
import goldenGirls from '../../images/teamLogos/Golden girls.png'
import graffix from '../../images/teamLogos/Graffix.png'
import grenlockMonsters from '../../images/teamLogos/Grenlock monsters.png'
import heathens from '../../images/teamLogos/Heathens.png'
import hiredGuns from '../../images/teamLogos/Hired Guns.png'
import invaders from '../../images/teamLogos/Invaders.png'
import mallards from '../../images/teamLogos/Mallards.png'
import mooseKnuckles from '../../images/teamLogos/mooseKnuckles.png'
import redWolves from '../../images/teamLogos/redWolves.PNG'
import sassNSpades from '../../images/teamLogos/sassNSpades.PNG'
import midnightExpress from '../../images/teamLogos/Midnight express.png'
import misfits from '../../images/teamLogos/Misfits Coed.png'
import missConducts from '../../images/teamLogos/Miss conducts.jpg'
import nightswatchBlack from '../../images/teamLogos/Nightswatch Black.png'
import nightswatchWhite from '../../images/teamLogos/Nightswatch White.png'
import ninjaTurtles from '../../images/teamLogos/Ninja turtles.jpg'
import nukes from '../../images/teamLogos/Nukes.png'
import pigeons from '../../images/teamLogos/Ny pigeons.png'
import purplePower from '../../images/teamLogos/Purple power.png'
import roastMellows from '../../images/teamLogos/Roast mellows.png'
import rockies from '../../images/teamLogos/Rockies.png'
import ronin from '../../images/teamLogos/Ronin.png'
import saltyCrabsMensA from '../../images/teamLogos/Salty Crabs mens A.png'
import shortis from '../../images/teamLogos/Shortis Logo.PNG'
import sjCyclones from '../../images/teamLogos/SJ cyclones.png'
import sjEnforcers from '../../images/teamLogos/SJ enforcers.png'
import sjsharks from '../../images/teamLogos/SJ sharks.png'
import southBolts from '../../images/teamLogos/South bolts.jpg'
import southHillsBandits from '../../images/teamLogos/South Hills Bandit.png'
import southSiders from '../../images/teamLogos/South Siders.png'
import stallions from '../../images/teamLogos/Stallions.png'
import thugBunnies from '../../images/teamLogos/Thug bunnies.jpg'
import venom from '../../images/teamLogos/venom.png'
import caniseCarai from '../../images/teamLogos/Canise Carai.PNG'
import doggPound from '../../images/teamLogos/doggPound.png'
import ellasFellas from '../../images/teamLogos/ellasFellas.png'
import rabidRaccoons from '../../images/teamLogos/Rabid raccoons.png'
import stingrays from '../../images/teamLogos/stingrays.PNG'
import vengeance from '../../images/teamLogos/Vengeance.png'
import banksvilleBucks from '../../images/teamLogos/banksvilleBucks.PNG'
import mckeesportPaladins from '../../images/teamLogos/McKeesportPaladins.png'
import starhawks from '../../images/teamLogos/starhawks.PNG'
import bridgers from '../../images/teamLogos/bridgers.png'
import jhamericans from '../../images/teamLogos/JH_Americans.png'
import thrustfund from '../../images/teamLogos/ThrustFund.png'
import offsides from '../../images/teamLogos/offsides.PNG'

const TeamSchedule = () => {
	console.log('inside TeamSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	//const [teamId, setTeamId] = useState()
	const [leagueId, setLeagueId] = useState()
	const [year, setYear] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [allTeamGames, setAllTeamGames] = useState([])
	const [divisionName, setDivisionName] = useState()
	const [leagueName, setLeagueName] = useState()
	const [teamName, setTeamName] = useState()
	const [allPotentialPlayoffGames, setAllPotentialPlayoffGames] = useState()
	const [allGameStats, setAllGameStats] = useState()

	//
	const auth = useContext(AuthContext)

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])
	//
	//MATT:  I sent over other params as well (from FilterByTeam), but it looks like o only need teamId
	//
	const teamId = useParams().teamId
	console.log('useParams: ' + useParams())

	//Get all games for a team.  getTeamSchedule2.  Also returns teamId.
	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllTeamGames([])
			try {
				const response = await fetch(
					//`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${leagueName}/${divisionName}/${year}/${teamName}`
					`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${teamId}`,
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllTeamGames(responseData.allTeamGamesArray)
				setAllPotentialPlayoffGames(responseData.allPotentialPlayoffGamesArray)
				setAllGameStats(responseData.allGameStatsArray)
				//setTeamId(responseData.teamId)
				setTeamName(responseData.teamName)
				setYear(responseData.year)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueId(responseData.leagueId)
				setDivisionName(responseData.divisionName)
				setLeagueName(responseData.leagueName)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [teamId])
	//
	//
	const teamLogoMap = {
		'Backstrom Boys': backstromBoys,
		Berserkers: berserkers,
		'Black Widows': blackWidows,
		Bolts: bolts,
		Bombers: bombers,
		'Bonnie N Clyde': bonnieNClyde,
		'Capital Punishment': capitalPunishment,
		Chops: chops,
		Chernobyl: chernobyl,
		'Chimney Fish': chimneyFish,
		'DC Corruption': dcCorruption,
		'Eh-Holes': ehHoles,
		'First Ladies': firstLadies,
		Freeze: freeze,
		GJWTHF: gjwthf,
		'Golden Girls': goldenGirls,
		Graffix: graffix,
		'Grenlock Monsters': grenlockMonsters,
		Heathens: heathens,
		'Hired Guns': hiredGuns,
		Invaders: invaders,
		'Midnight Express': midnightExpress,
		Misfits: misfits,
		'Miss Conducts': missConducts,
		'Nights Watch Black': nightswatchBlack,
		'Nights Watch White': nightswatchWhite,
		'Ninja Turrles': ninjaTurtles,
		Nukes: nukes,
		Pigeons: pigeons,
		'Purple Power': purplePower,
		'Roast Mellows': roastMellows,
		Rockies: rockies,
		Ronin: ronin,
		'Salty Crabs': saltyCrabsMensA,
		Shortis: shortis,
		Cyclones: sjCyclones,
		Enforcers: sjEnforcers,
		Sharks: sjsharks,
		'South Bolts': southBolts,
		Bandits: southHillsBandits,
		'South Siders': southSiders,
		Stallions: stallions,
		'Thug Bunnies': thugBunnies,
		Venom: venom,
		'Chimney Fish': chimneyFish,
		'Nights Watch': nightswatchBlack,
		Mallards: mallards,
		'Sass N Spades': sassNSpades,
		'Raleigh Red Wolves': redWolves,
		'Moose Knuckles': mooseKnuckles,
		'Canise Carai-Pereira': caniseCarai,
		'Dogg Pound': doggPound,
		"Ella's Fellas": ellasFellas,
		'Rabid Raccoons': rabidRaccoons,
		Stingrays: stingrays,
		Vengeance: vengeance,
		'Banksville Bucks': banksvilleBucks,
		McKeesport: mckeesportPaladins,
		StarHawks: starhawks,
		Bridgers: bridgers,
		'JH Americans': jhamericans,
		'Thrust Fund': thrustfund,
		Offsides: offsides,
	}
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${months[game.date.substr(0, 2)]} ${game.date.substr(3, 2)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		return game.score
	}
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	let rem

	if (allTeamGames) {
		//console.log('assignedPlayers: ' + assignedPlayers)
		if (allTeamGames.length > 10) {
			rem = '2rem'
		} else {
			rem = '20rem'
		}
	}
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allTeamGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				<SearchByLeagueOrVenue />
				{/* <div style={{ marginTop: '5rem' }}>
					<SearchByTeam />
				</div> */}
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (
		!isLoading &&
		allGameStats &&
		allGameStats.length > -1 &&
		allTeamGames.length !== 0
	) {
		dateBlock.push(
			<React.Fragment>
				<div className='Schedule'>
					<SearchByLeagueOrVenue />
					{/* <SearchByTeam /> */}

					<div className='teamScheduleHeroMobile'>
						{teamLogoMap[teamName] && (
							<img
								src={teamLogoMap[teamName]}
								alt={teamName}
								className='teamScheduleHeroWatermark'
							/>
						)}

						<div className='teamScheduleHeroContent'>
							<h2>{teamName}</h2>

							<div className='teamScheduleHeroPill'>
								<div className='teamScheduleHeroLeague'>
									{leagueName} {year}
								</div>
								<div className='teamScheduleHeroDivision'>{divisionName}</div>
							</div>

							<div className='teamScheduleHeroDivider'>
								<span></span>
								<span></span>
							</div>

							<div className='teamScheduleHeroRecordLabel'>Record</div>

							<div className='teamScheduleHeroRecordGrid'>
								<div>
									<strong>{wins}</strong>
									<span>Wins</span>
								</div>

								<div>
									<strong>{losses}</strong>
									<span>Losses</span>
								</div>

								<div>
									<strong>
										{(shootoutLosses || 0) +
											(overtimeLosses || 0) +
											(ties || 0)}
									</strong>
									<span>SOL</span>
								</div>
							</div>
						</div>
					</div>

					<div className='teamScheduleDesktopInfo'>
						<h1>{teamName}</h1>
						<h3 className='h3Center'>
							{allTeamGames[0].year + ' ' + allTeamGames[0].leagueName}
						</h3>
						<h3 className='h3Center'>
							{allTeamGames[0].divisionName + ' Division '}
						</h3>
						<h3 className='h3Center'>
							Record: {wins} - {losses} -{' '}
							{ties + shootoutLosses + overtimeLosses}
						</h3>
						<p className='clickOn'>
							(Click on the final score of a game to see a Game Summary)
						</p>
					</div>
					<table id='teamScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								<th>Opponent</th>
								<th>Score</th>
								<th>Pts.</th>
							</tr>
						</thead>
						<tbody>
							{allTeamGames.map((game, key) => {
								// if (game.venueName === venue) {
								return (
									<tr key={key}>
										<td>
											{game.dayOfWeek}
											{', '}
											{game.date.substr(0, 2) === '01' &&
												'Jan. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '02' &&
												'Feb. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '03' &&
												'Mar. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '04' &&
												'Apr. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '05' &&
												'May ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '06' &&
												'June ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '07' &&
												'July ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '08' &&
												'Aug. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '09' &&
												'Sept. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '10' &&
												'Oct. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '11' &&
												'Nov. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '12' &&
												'Dec. ' + game.date.substr(3, 2)}
											{/* </td>
									<td> */}
											{', '}
											{game.time.substr(0, 2) === '00' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '01' &&
												'1:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '02' &&
												'2:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '03' &&
												'3:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '04' &&
												'4:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '05' &&
												'5:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '06' &&
												'6:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '07' &&
												'7:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '08' &&
												'8:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '09' &&
												'9:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '10' &&
												'10:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '11' &&
												'11:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '12' &&
												'12:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '13' &&
												'1:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '14' &&
												'2:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '15' &&
												'3:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '16' &&
												'4:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '17' &&
												'5:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '18' &&
												'6:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '19' &&
												'7:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '20' &&
												'8:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '21' &&
												'9:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '22' &&
												'10:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '23' &&
												'11:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '24' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{/* </td>
									<td> */}
											<br></br>
											{game.venueName}
										</td>
										{/* <td>
										{(game.status && game.status !== 'TBP' && (
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												{game.status}
											</Link>
										)) ||
											'TBP'}
									</td> */}

										{game.homeTeamName === teamName && (
											<td>
												{game.visitorTeamName} <br></br>
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}
										{game.visitorTeamName === teamName && (
											<td>
												@ {game.homeTeamName}
												<br></br>
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}
										{!game.score && <td></td>}
										{game.score && !game.winner && !game.loser && (
											<td style={{ color: 'black', fontWeight: 'bold' }}>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'black',
													}}
													to={`/gameSummary/${game._id}`}
												>
													TIED {game.score}
												</Link>
											</td>
										)}
										{game.loser === teamId && (
											<td style={{ color: 'red', fontWeight: 'bold' }}>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'red',
													}}
													to={`/gameSummary/${game._id}`}
												>
													LOST {game.score}
													{game.status === 'SO' && ' (SO)'}
													{game.status === 'OT' && ' (OT)'}
												</Link>
											</td>
										)}
										{game.winner === teamId && (
											<td style={{ color: 'green', fontWeight: 'bold' }}>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'green',
													}}
													to={`/gameSummary/${game._id}`}
												>
													WON {game.score}
													{game.status === 'SO' && ' (SO)'}
													{game.status === 'OT' && ' (OT)'}
												</Link>
											</td>
										)}
										{game.homeTeamId === teamId &&
											allGameStats[key] !== null && (
												<td>
													{JSON.stringify(allGameStats[key].homePointsAwarded)}
												</td>
											)}
										{game.visitorTeamId === teamId &&
											allGameStats[key] !== null && (
												<td>
													{JSON.stringify(
														allGameStats[key].visitorPointsAwarded,
													)}
												</td>
											)}
										{allGameStats[key] === null && <td></td>}
										{/* <td style={{ color: 'red', fontWeight: 'bold' }}>
										{game.playoff && game.description}
									</td>
									<td>
										{game.visitorTeamSeed > 0 &&
											'(' + game.visitorTeamSeed + ') '}
										{game.visitorTeamName && game.visitorTeamName}
										{' @ '}
										{game.homeTeamSeed > 0 && '(' + game.homeTeamSeed + ') '}
										{game.homeTeamName && game.homeTeamName}
										
									</td> */}
										{/* <td>{game.venueName}</td> */}
									</tr>
								)
								//}
							})}
						</tbody>
					</table>
					<div className='scheduleCardsMobile'>
						{allTeamGames.map((game, key) => {
							const visitorLogo = teamLogoMap[game.visitorTeamName]
							const homeLogo = teamLogoMap[game.homeTeamName]

							return (
								<div
									className={`scheduleCard ${
										game.playoff || game.championship || game.description
											? 'scheduleCardPlayoff'
											: ''
									}`}
									key={`team-mobile-${key}`}
								>
									<div className='scheduleCard__header'>
										<div>{formatGameDate(game)}</div>

										<div className='scheduleCard__divisionHeader'>
											<div>{divisionName}</div>

											{game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.description}
												</span>
											)}
										</div>

										<div>{formatGameTime(game)}</div>
									</div>

									<div className='scheduleCard__body'>
										<div className='scheduleCard__team'>
											{homeLogo && (
												<img src={homeLogo} alt={game.homeTeamName} />
											)}
											<span
												className={
													game.winner === game.homeTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.homeTeamName}
											</span>
										</div>

										<div className='scheduleCard__scoreBox'>
											{game.score ? (
												<Link
													to={`/gameSummary/${game._id}`}
													className='scheduleCard__score'
												>
													{getDisplayScore(game)}
												</Link>
											) : (
												<div className='scheduleCard__score'>TBP</div>
											)}

											{game.score && (
												<div className='scheduleCard__status'>
													{game.status === 'SO'
														? 'SO'
														: game.status === 'OT'
															? 'OT'
															: 'FINAL'}
												</div>
											)}
										</div>

										<div className='scheduleCard__team'>
											{visitorLogo && (
												<img src={visitorLogo} alt={game.visitorTeamName} />
											)}
											<span
												className={
													game.winner === game.visitorTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.visitorTeamName}
											</span>
										</div>
									</div>

									<div className='scheduleCard__venue'>📍 {game.venueName}</div>
								</div>
							)
						})}
					</div>
				</div>
				<div className='Schedule' style={{ marginTop: '7rem' }}>
					<h3 className='h3Center'>{divisionName} Playoff Games</h3>
					<table id='teamScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								<th>Visitor/Home</th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							{allPotentialPlayoffGames.map((game, key) => {
								// if (game.venueName === venue) {
								return (
									<tr key={key}>
										<td>
											{game.dayOfWeek}
											{', '}
											{game.date.substr(0, 2) === '01' &&
												'Jan. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '02' &&
												'Feb. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '03' &&
												'Mar. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '04' &&
												'Apr. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '05' &&
												'May ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '06' &&
												'June ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '07' &&
												'July ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '08' &&
												'Aug. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '09' &&
												'Sept. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '10' &&
												'Oct. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '11' &&
												'Nov. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '12' &&
												'Dec. ' + game.date.substr(3, 2)}
											{/* </td>
									<td> */}
											{', '}
											{game.time.substr(0, 2) === '00' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '01' &&
												'1:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '02' &&
												'2:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '03' &&
												'3:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '04' &&
												'4:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '05' &&
												'5:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '06' &&
												'6:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '07' &&
												'7:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '08' &&
												'8:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '09' &&
												'9:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '10' &&
												'10:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '11' &&
												'11:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '12' &&
												'12:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '13' &&
												'1:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '14' &&
												'2:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '15' &&
												'3:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '16' &&
												'4:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '17' &&
												'5:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '18' &&
												'6:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '19' &&
												'7:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '20' &&
												'8:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '21' &&
												'9:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '22' &&
												'10:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '23' &&
												'11:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '24' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{/* </td>
									<td> */}
											<br></br> {game.venueName}
										</td>
										{/* //
										//
										//    Visitor/Home
										//
										// */}
										{game.visitorTeamName && (
											<td>
												{game.visitorTeamSeed > 0 &&
													'(' + game.visitorTeamSeed + ') '}
												{game.visitorTeamName && game.visitorTeamName}
												{' @ '}
												{game.homeTeamSeed > 0 &&
													'(' + game.homeTeamSeed + ') '}
												{game.homeTeamName && game.homeTeamName}
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}
										{auth.isLoggedIn && (
											<td>
												{game.playoff &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/playoffGameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{!game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/gameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													(game.homeTeamName === 'TBD' ||
														game.visitorTeamName === 'TBD') && (
														<NavLink
															className='navlinksEnterTeams'
															to={`/admin/updateGame/${game._id}`}
															exact
														>
															TEAMS
														</NavLink>
													)}
											</td>
										)}
										{/* //
										//
										//    Winner
										//
										// */}
										{game.homeTeamId && game.winner === game.homeTeamId && (
											<td>{game.homeTeamName}</td>
										)}
										{game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>{game.visitorTeamName}</td>
											)}
										{game.status &&
											game.status !== 'TBP' &&
											game.winner !== game.homeTeamId &&
											game.winner !== game.visitorTeamId && <td>TIE</td>}
										{!game.score && <td></td>}
										{/* //
										//
										//    Score
										//
										// */}
										<td
											style={{
												textDecoration: 'none',
												fontWeight: 600,
												color: 'black',
											}}
										>
											{game.score}
											{game.status === 'SO' && ' (SO)'}
											{game.status === 'OT' && ' (OT)'}
										</td>
									</tr>
								)
								//}
							})}
						</tbody>
					</table>
					<div className='scheduleCardsMobile'>
						{allPotentialPlayoffGames.map((game, key) => {
							const visitorLogo = teamLogoMap[game.visitorTeamName]
							const homeLogo = teamLogoMap[game.homeTeamName]

							return (
								<div
									className={`scheduleCard scheduleCardPlayoff`}
									key={`team-playoff-mobile-${key}`}
								>
									<div className='scheduleCard__header'>
										<div>{formatGameDate(game)}</div>

										<div className='scheduleCard__divisionHeader'>
											<div>PLAYOFF</div>

											{game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.description}
												</span>
											)}
										</div>

										<div>{formatGameTime(game)}</div>
									</div>

									<div className='scheduleCard__body'>
										<div className='scheduleCard__team'>
											{homeLogo && (
												<img src={homeLogo} alt={game.homeTeamName} />
											)}
											<span
												className={
													game.winner === game.homeTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
												{game.homeTeamName}
											</span>
										</div>

										<div className='scheduleCard__scoreBox'>
											{game.score ? (
												<div className='scheduleCard__score'>
													{getDisplayScore(game)}
												</div>
											) : (
												<div className='scheduleCard__score'>TBP</div>
											)}

											{game.score && (
												<div className='scheduleCard__status'>
													{game.status === 'SO'
														? 'SO'
														: game.status === 'OT'
															? 'OT'
															: 'FINAL'}
												</div>
											)}
										</div>

										<div className='scheduleCard__team'>
											{visitorLogo && (
												<img src={visitorLogo} alt={game.visitorTeamName} />
											)}
											<span
												className={
													game.winner === game.visitorTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.visitorTeamSeed > 0 &&
													`(${game.visitorTeamSeed}) `}
												{game.visitorTeamName}
											</span>
										</div>
									</div>

									<div className='scheduleCard__venue'>📍 {game.venueName}</div>

									{game.championship && (
										<div className='scheduleCard__description'>
											CHAMPIONSHIP GAME
										</div>
									)}
								</div>
							)
						})}
					</div>
				</div>
			</React.Fragment>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				{!isMobile && (
					<div style={{ marginTop: '5rem' }}>
						<Banner />
					</div>
				)}
				{dateBlock && dateBlock}
				<div>
					<Footer />
				</div>
			</React.Fragment>
		</div>
	)
}

export default TeamSchedule
